module.exports = __webpack_public_path__ + "img/prj-card1.dcdea6c8.png";